import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import NotFound from './pages/NotFound';
import ThankYou from './pages/ThankYou';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

import { store } from './redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist'; //with persist

// pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Music from './pages/Music';
import Movies from './pages/Movies';
import TurnTables from './pages/TurnTables';
import Deals from './pages/Deals';
import Listing from './pages/Listing';
import ProductDetails from './pages/ProductDetails';
import Cart from './pages/Cart';
import Login from './pages/Login';
import Register from './pages/Register';
import Myorder from './pages/Myorder';
import OrderHistory from './pages/OrderHistory';
import AdminLogin from './admin/pages/AdminLogin';
import AdminDashboard from './admin/pages/Dashboard';
import Categories from './admin/pages/Categories';
import SubCategories from './admin/pages/SubCategories';
import ShippingCharges from './admin/pages/ShippingCharges';
import Formats from './admin/pages/Formats';
import ProductFilters from './admin/pages/ProductFilters';
import Products from './admin/pages/Products';
import ProductOffers from './admin/pages/ProductOffers';
import ProductDeals from './admin/pages/ProductDeals';
import AllOrders from './admin/pages/AllOrders';
import Sliders from './admin/pages/Sliders';
import Users from './admin/pages/Users';
import Testimonials from './admin/pages/Testimonials';
import Feedbacks from './admin/pages/Feedbacks';
import Promotions from './admin/pages/Promotions';
import PageSeo from './admin/pages/PageSeo';
import HomepageProducts from './admin/pages/HomepageProducts';
import Blogs from './admin/pages/Blogs';
import ContactForm from './admin/pages/ContactForm';
import BlogDetail from './pages/BlogDetail';

import Offers from './pages/Offers';
import Checkout from './pages/Checkout';
import BillingAddress from './pages/BillingAddress';
import Invoice from './pages/Invoice';

import Layouts from './admin/Layouts';
import AdminLayout from './admin/AdminLayout';

import ExclusiveProducts from './pages/sectionproducts/ExclusiveProducts';
import BestSellersEnglish from './pages/sectionproducts/BestSellersEnglish';
import BestSellersHindi from './pages/sectionproducts/BestSellersHindi';
import BoxSets from './pages/sectionproducts/BoxSets';
import NewReleaseEnglish from './pages/sectionproducts/NewReleaseEnglish';
import NewReleaseHindi from './pages/sectionproducts/NewReleaseHindi';
import PreBook from './pages/sectionproducts/PreBook';
import NewReleaseTamil from './pages/sectionproducts/NewReleaseTamil';

import NewRelease from './pages/NewRelease';
import UpcomingRelease from './pages/UpcomingRelease';
import BestSellers from './pages/BestSellers';
import SiteMap from './pages/SiteMap';
import Terms from './pages/Terms';
import ForgetPassword from './pages/ForgetPassword';
import ResetPassword from './pages/ResetPassword';
import Searchresult from './pages/Searchresult';

import UnderConstruction from './pages/UnderConstruction';

import TestHome from './pages/TestHome';

import ProductPage from './pages/ProductPage';
import ProductInvoice from './pages/ProductInvoice';

import ProductPageChhava from './pages/ProductPageChhava';

import ProductOrders from './admin/pages/ProductOrders';

import NotifyEnquiries from './admin/pages/NotifyEnquiries';

import Artists from './admin/pages/Artists';
import TurnTableListing from './pages/TurnTableListing';

import TurnTableProducts from './admin/pages/TurnTableProducts';

let persistor = persistStore(store); //with persis

const router = createBrowserRouter(


  createRoutesFromElements(
    <>
    {/* <Route exact path="/" element={<UnderConstruction />} /> */}
    
    
    <Route path="/" element={<App />}>
      <Route index element={<Home />} />
      <Route path='home' element={<Home />} />
      <Route path='testhome' element={<TestHome />} />
      <Route path="about-us" element={<About />} />
      <Route path="services" element={<Services />} />
      <Route path="music" element={<Music />} />
      <Route path="movies" element={<Movies />} />
      <Route path="turntables" element={<TurnTables />} />
      {/* <Route path="listing" element={<Listing />} /> */}
      <Route path="entertainment/:slug" element={<ProductDetails />} />
      <Route path="deals" element={<Deals />} />
      <Route path="cart" element={<Cart />} />
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="myorder" element={<Myorder />} />
      <Route path="orderhistory" element={<OrderHistory />} />
      <Route path="contact-us" element={<Contact />} />
      <Route path='offers/:link' element={<Offers />} />
      <Route path='sub-category/:subcategory/:category' element={<Listing />} />
      <Route path='turntables/:subcategory' element={<TurnTableListing />} />
      <Route path='searchresult' element={<Searchresult />} />
      <Route path='checkout' element={<Checkout />} />
      <Route path='thank-you' element={<ThankYou />} />
      <Route path='billing-address' element={<BillingAddress />} />
      <Route path='blog/:slug' element={<BlogDetail />} />

      <Route path='exclusive-products' element={<ExclusiveProducts />} />
      <Route path='new-release-hindi' element={<NewReleaseHindi />} />
      <Route path='new-release-english' element={<NewReleaseEnglish />} />
      <Route path='new-release-tamil' element={<NewReleaseTamil />} />
      <Route path='pre-book' element={<PreBook />} />
      <Route path='bestsellers-hindi' element={<BestSellersHindi />} />
      <Route path='bestsellers-english' element={<BestSellersEnglish />} />
      <Route path='box-sets' element={<BoxSets />} />


      <Route path='new-releases-products' element={<NewRelease />} />
      <Route path='upcoming-releases-products' element={<UpcomingRelease />} />
      <Route path='bestsellers-products' element={<BestSellers />} />
      <Route path='sitemap' element={<SiteMap />} />
      <Route path='terms' element={<Terms />} />
      <Route path='forget-password' element={<ForgetPassword />} />
      <Route path='reset-password/:slug' element={<ResetPassword />} />
      <Route path='*' element={<NotFound />} />


    </Route>

    <Route path='product/sanamterikasam' element={<ProductPage />} />
    <Route path='/invoice/productinvoice/:orderid' element={<ProductInvoice />} />

    <Route path='product/chhaava' element={<ProductPageChhava />} />

    

    <Route path='/invoice/:orderid' element={<Invoice />} />

    {/* adminlogin */}
    <Route path="/" element={<Layouts />}>
       <Route path='/admin' element={<AdminLogin />} />
       <Route path='/admin/login' element={<AdminLogin />} />
    </Route>

    <Route path="/" element={<AdminLayout />}>
      <Route path='/admin/home' element={<AdminDashboard />} />
      <Route path='/admin/dashboard' element={<AdminDashboard />} />
      <Route path='/admin/category' element={<Categories />} />
      <Route path='/admin/sub-category' element={<SubCategories />} />
      <Route path='/admin/shipping-charges' element={<ShippingCharges />} />
      <Route path='/admin/formats' element={<Formats />} />
      <Route path='/admin/genre' element={<ProductFilters />} />
      <Route path='/admin/artists' element={<Artists />} />
      <Route path='/admin/product' element={<Products />} />
      <Route path='/admin/turntable-products' element={<TurnTableProducts />} />
      <Route path='/admin/offers' element={<ProductOffers />} />
      <Route path='/admin/deals' element={<ProductDeals />} />
      <Route path='/admin/all-orders' element={<AllOrders />} />
      <Route path='/admin/productorders' element={<ProductOrders />} />
      <Route path='/admin/sliders' element={<Sliders />} />
      <Route path='/admin/users' element={<Users />} />
      <Route path='/admin/testimonials' element={<Testimonials />} />
      <Route path='/admin/userFeedbackList' element={<Feedbacks />} />
      <Route path='/admin/promotions' element={<Promotions />} />
      <Route path='/admin/seo' element={<PageSeo />} />
      <Route path='/admin/homepage-products' element={<HomepageProducts />} />
      <Route path='/admin/blogs' element={<Blogs />} />
      <Route path='/admin/contactform' element={<ContactForm />} />
      <Route path='/admin/notifyenquiries' element={<NotifyEnquiries />} />
    </Route>
    
</>
  )
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <Provider store={store}>
    <PersistGate persistor={persistor}>
    <RouterProvider router={router} />
    </PersistGate>
     </Provider>
  </>
);


